import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_BANK_DETAIL = 'FETCH_BANK_DETAIL';

const apiCall = createApiCall(FETCH_BANK_DETAIL, params => ({
  endpoint: generateEndpoint({
    host: `/api/admin/banks/${params.id}`,
  }),
  method: 'GET',
}));

export default apiCall;
